import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import {
  TfgSettingsPutDto,
  TfgSettingsWebDto,
} from '@/features/dashboard/tfg/types/TfgSettingsDto.ts';
import { AirportDto } from '@/features/dashboard/tfg/types/AirportDto.ts';
import { TfgDeklaracjaPreviewDto } from '@/features/dashboard/tfg/types/TfgDeklaracjaPreviewDto.ts';
import { TfgHistory } from '@/features/dashboard/tfg/types/TfgHistoryDto.ts';

const tfgApi = {
  getSettings: (tourId: string): Promise<TfgSettingsWebDto> =>
    fetchPrivateApi<TfgSettingsWebDto>('GET', `tours/${tourId}/tfg-settings`),

  putSettings: (
    tourId: string,
    dto: TfgSettingsPutDto,
  ): Promise<TfgSettingsWebDto> =>
    fetchPrivateApi<TfgSettingsWebDto>(
      'PUT',
      `tours/${tourId}/tfg-settings`,
      dto,
    ),

  /** Returns the full airport dictionary in one call; filtered client-side. */
  getAirports: (): Promise<AirportDto[]> =>
    fetchPrivateApi<AirportDto[]>('GET', 'tfg/airports'),

  /**
   * Live, read-only projection of the monthly TFG declaration. Nothing is
   * persisted — safe to re-fetch on every period change.
   */
  getDeklaracjaPreview: (
    year: number,
    month: number,
  ): Promise<TfgDeklaracjaPreviewDto> =>
    fetchPrivateApi<TfgDeklaracjaPreviewDto>(
      'GET',
      `tfg/deklaracja-preview?year=${year}&month=${month}`,
    ),

  /** Regulatory TFG timeline for a client (BE-16). Always 200, may be empty. */
  getClientHistory: (clientId: string): Promise<TfgHistory> =>
    fetchPrivateApi<TfgHistory>('GET', `tfg/clients/${clientId}/history`),

  /** Regulatory TFG timeline for a participant (BE-16). Always 200, may be empty. */
  getParticipantHistory: (participantId: string): Promise<TfgHistory> =>
    fetchPrivateApi<TfgHistory>(
      'GET',
      `tfg/participants/${participantId}/history`,
    ),
};

export default tfgApi;
